import React, {PureComponent} from 'react';
import {Portal} from '../Portal/Portal';
import {ModalWrapper} from './ModalWrapper';
import {Backdrop} from '../Backdrop/Backdrop';

export interface ModalProps {
    /**
     * When `true`, modal is open and be rendered in a Portal.
     */
    open: boolean;
    /**
     * When `true`, backdrop will render with zero opacity.
     */
    transparentBackdrop: boolean;
    /**
     * When `true`, clicking Backdrop won't trigger onClose event.
     * This requires `hideBackdrop` to be `false`.
     */
    disableBackdropClick: boolean;
    /**
     * When `true`, backdrop will not be rendered.
     */
    hideBackdrop: boolean;
    /**
     * Callback fired when Modal requests to be closed.
     */
    onClose?: VoidFunction;
}

type Props = ModalProps;

// TODO: WIP: NOT READY TO BE USED
/**
 * A simple modal container with optional backdrop.
 * When open, will render children inside of a fixed position
 * container covering entire window.
 *
 * @todo: add focus trap and event handler.
 */
export class Modal extends PureComponent<Props> {
    public static defaultProps = {
        transparentBackdrop: false,
        disableBackdropClick: false,
        hideBackdrop: false
    };

    public render() {
        if (this.props.open !== true) {
            return null;
        }

        return (
            <Portal>
                <ModalWrapper>
                    {this.props.hideBackdrop ? null : (
                        <Backdrop
                            transparent={this.props.transparentBackdrop}
                            onClick={
                                this.props.disableBackdropClick ? undefined : this.props.onClose
                            }
                        />
                    )}
                    {this.props.children}
                </ModalWrapper>
            </Portal>
        );
    }
}
